import apiSerial from '@/api/vo-general/serial';

const defaultState = () => ({
	serialType: [],
  serialStarList: [],
	serialStarPagination: {},
	serialEliteList: [],
	serialElitePagination: {},
	serialEkonomiList: [],
	serialEkonomiPagination: {},
	serialCeriaList: [],
	serialCeriaPagination: {},
	serialSupremeList: [],
	serialSupremePagination: {},
	serialROList: [],
	serialROPagination: {},
	historySerialList: [],
	historySerialPagination: {},
	detailHistorySerialList: [],
	detailHistorySerialPagination: {},
	historyTransaksiSerialList: [],
	historyTransaksiSerialPagination: {},
	serialAvailList: [],
});

const state = defaultState();

const getters = {
};

const mutations = {
	setSerialType(state, data) {
		state.serialType = data.data
	},
	setSerialStarList(state, data) {
		state.serialStarList = data.results
		state.serialStarPagination = data.pagination
	},
	setSerialEliteList(state, data) {
		state.serialEliteList = data.results
		state.serialElitePagination = data.pagination
	},
	setSerialEkonomiList(state, data) {
		state.serialEkonomiList = data.results
		state.serialEkonomiPagination = data.pagination
	},
	setSerialCeriaList(state, data) {
		state.serialCeriaList = data.results
		state.serialCeriaPagination = data.pagination
	},
	setSerialSupremeList(state, data) {
		state.serialSupremeList = data.results
		state.serialSupremePagination = data.pagination
	},
	setSerialROList(state, data) {
		state.serialROList = data.results
		state.serialROPagination = data.pagination
	},
	setLoadSerialStarList(state, data) {
		state.serialStarList = [...state.serialStarList, ...data.results]
		state.serialStarPagination = data.pagination
	},
	setLoadSerialEliteList(state, data) {
		state.serialEliteList = [...state.serialEliteList, ...data.results]
		state.serialElitePagination = data.pagination
	},
	setLoadSerialEkonomiList(state, data) {
		state.serialEkonomiList = [...state.serialEkonomiList, ...data.results]
		state.serialEkonomiPagination = data.pagination
	},
	setLoadSerialCeriaList(state, data) {
		state.serialCeriaList = [...state.serialCeriaList, ...data.results]
		state.serialCeriaPagination = data.pagination
	},
	setLoadSerialSupremeList(state, data) {
		state.serialSupremeList = [...state.serialSupremeList, ...data.results]
		state.serialSupremePagination = data.pagination
	},
	setLoadSerialROList(state, data) {
		state.serialROList = [...state.serialROList, ...data.results]
		state.serialROPagination = data.pagination
	},
	setHistorySerialList(state, data) {
		state.historySerialList = data.results
		state.historySerialPagination = data.pagination
	},
	setDetailHistorySerialList(state, data) {
		state.detailHistorySerialList = data.results
		state.detailHistorySerialPagination = data.pagination
	},
	setHistoryTransaksiSerialList(state, data) {
		state.historyTransaksiSerialList = data.results
		state.historyTransaksiSerialPagination = data.pagination
	},
	setSerialAvailList(state, data) {
		state.serialAvailList = data.results
	},
	clearSerialAvailList(state, data) {
		state.serialAvailList = data
	},
};

const actions = {
	getSerialType({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialType(params).then((results) => {
				const data = results.data.data
				commit('setSerialType', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getSerialStarList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialStarList(params).then((results) => {
				const data = results.data.data
				commit('setSerialStarList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getSerialEliteList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialEliteList(params).then((results) => {
				const data = results.data.data
				commit('setSerialEliteList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getSerialEkonomiList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialEkonomiList(params).then((results) => {
				const data = results.data.data
				commit('setSerialEkonomiList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getSerialCeriaList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialCeriaList(params).then((results) => {
				const data = results.data.data
				commit('setSerialCeriaList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getSerialSupremeList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialSupremeList(params).then((results) => {
				const data = results.data.data
				commit('setSerialSupremeList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getSerialROList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialROList(params).then((results) => {
				const data = results.data.data
				commit('setSerialROList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getLoadSerialStarList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialStarList(params).then((results) => {
				const data = results.data.data
				commit('setLoadSerialStarList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getLoadSerialEliteList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialEliteList(params).then((results) => {
				const data = results.data.data
				commit('setLoadSerialEliteList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getLoadSerialEkonomiList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialEkonomiList(params).then((results) => {
				const data = results.data.data
				commit('setLoadSerialEkonomiList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getLoadSerialCeriaList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialCeriaList(params).then((results) => {
				const data = results.data.data
				commit('setLoadSerialCeriaList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getLoadSerialSupremeList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialSupremeList(params).then((results) => {
				const data = results.data.data
				commit('setLoadSerialSupremeList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getLoadSerialROList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getSerialROList(params).then((results) => {
				const data = results.data.data
				commit('setLoadSerialROList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	sendSerial({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.sendSerial(params).then((results) => {
				const data = results.data
				dispatch('success', data, { root : true });
				resolve(data)
			}).catch((err) => {
				reject(err.response);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getHistorySerialList({ dispatch, commit },  params) {
		return new Promise((resolve, reject) => {
			apiSerial.getHistorySerialList(params).then((results) => {
				const data = results.data.data
				commit('setHistorySerialList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getDetailHistorySerialList({ dispatch, commit },  params) {
		return new Promise((resolve, reject) => {
			apiSerial.getDetailHistorySerialList(params).then((results) => {
				const data = results.data.data
				commit('setDetailHistorySerialList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getSerialAvailList({ dispatch, commit }, params) {
		commit('clearSerialAvailList', [])
		return new Promise((resolve, reject) => {
			apiSerial.getSerialAvailList(params).then((results) => {
				const data = results.data.data
				commit('setSerialAvailList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	clearSerialAvailList({ commit }) {
			commit('clearSerialAvailList', [])
	},

	getHistoryTransaksiSerial({ dispatch, commit },  params) {
		return new Promise((resolve, reject) => {
			apiSerial.getHistoryTransaksiSerial(params).then((results) => {
				const data = results.data.data
				commit('setHistoryTransaksiSerialList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},

	getNewOTP({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.getNewOTP(params).then((results) => {
				const data = results.data
				dispatch('success', data, { root : true });
				resolve(data)
			}).catch((err) => {
				reject(err.response);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	verifyOTP({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiSerial.verifyOTP(params).then((results) => {
				const data = results.data
				// dispatch('success', data, { root : true });
				resolve(data)
			}).catch((err) => {
				reject(err.response);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};